import React, { useEffect, useState } from "react";

import ProtectedRoute from "../../components/ProtectedRoute";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import { componentOrderService } from "../../services/api";
import styles from "./Dashboard.module.css";
import OrdersOverview from "./OrdersOverview";

function Dashboard() {
  const [ordersSummary, setOrdersSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrdersSummary = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await componentOrderService.getDashboardSummary();
        setOrdersSummary(response.data.data);
      } catch (err) {
        console.error("Error fetching dashboard summary:", err);
        setError("Failed to load dashboard overview");
      } finally {
        setLoading(false);
      }
    };

    fetchOrdersSummary();
  }, []);

  return (
    <div className={styles.container}>
      <PageHeader title="Dashboard" subtitle="System overview at a glance" />

      <ProtectedRoute requiredAnyRole={["admin", "manager", "technician", "viewer"]}>
        {loading ? (
          <Loading loadingText="Loading dashboard overview..." />
        ) : error ? (
          <div className={styles.errorState}>{error}</div>
        ) : (
          <div className={styles.modulesGrid}>
            <OrdersOverview summary={ordersSummary} />
          </div>
        )}
      </ProtectedRoute>
    </div>
  );
}

export default Dashboard;
